import BigNumber from 'bignumber.js';

export const toCents = (value: number): number =>
  new BigNumber(value).times(100).integerValue(BigNumber.ROUND_HALF_UP).toNumber();

export const fromCents = (value: number): string => new BigNumber(value).div(100).toFixed(2);

export const fromCentsAsNumber = (value: number): number => new BigNumber(value).div(100).toNumber();

export const formatCurrency = (value: number): string => new BigNumber(value).toFixed(2);
